/*--------------------------------------------------------------------------*
 * ハンバーガーメニュー
 *--------------------------------------------------------------------------*/
$(function(){
    if ($(window).width() < 768) {
        $('[data-nav-trigger], [data-nav] a').on('click', function(){
            $('[data-nav-trigger]').toggleClass('active');
            $('[data-nav]').fadeToggle();
        });
    }
});
